import convert from 'convert-units';
import { round } from 'lodash';

export const inchesToMm = (n) => round(convert(n).from('in').to('mm'), 2);
export const mmToInches = (n) => round(convert(n).from('mm').to('in'), 2);
